import {Component, Input} from '@angular/core';
import {RankDto} from '../../../../../Models/Rrhh/Clock-In/clock-in-list.interface';
import {ClockInStatusEnum} from '../../../../../Shared/Enum/clock-in-status.enum';
import {ControllerComponent} from '../../../../Controller/controller-component';

@Component({
  selector: 'app-clock-in-item',
  templateUrl: './clock-in-item.component.html',
  styleUrls: ['./clock-in-item.component.scss'],
  standalone: false
})
export class ClockInItemComponent extends ControllerComponent {
  @Input() item!: RankDto;

  clockInStatusEnum = ClockInStatusEnum;
}
